import React from 'react';
import { PageSection, CardSummary, useGlobal } from '@rcg/ui-react';
import { Box, Paper, Divider } from '@material-ui/core';
import useStyles from './index.styles';
import {
  getDurationLabel,
  getStopsCodes,
  layover,
  lastDestination,
  layoverDays,
} from '../../commons';
import { OUTBOUND, INBOUND } from '../../commons/constants';
import { getAirlines } from '../../commons/utils';

const FlightSummary = ({ flight, passengers }) => {
  const classes = useStyles();
  const {
    renderContent,
    data: { localizedDayjs },
  } = useGlobal();
  let flights = flight?.filter(
    (route) => route.routeDirection === OUTBOUND || route.routeDirection === INBOUND,
  );
  // eslint-disable-next-line
  flights = flight?.map((flight) => {
    const flightSegment = flight.flightSegments[0];
    const departureflightNumber = flightSegment.number;
    const { routeDirection } = flight;
    let routeDirectionLabel = '';
    let routeIndex = 0;
    switch (routeDirection) {
      case OUTBOUND:
        routeDirectionLabel = renderContent('flightSummaryBookingAmendOutboundTitle', 'Departing');
        routeIndex = 1;
        break;
      case INBOUND:
        routeDirectionLabel = renderContent('flightSummaryBookingAmendInboundTitle', 'Returning');
        routeIndex = 2;
        break;
      default:
        break;
    }

    const stops = flight.numberOfStops > 0 ? flight.flightSegments : '';
    const stopCodes = stops && getStopsCodes(stops).join(', ');
    const segmentLayover = layover(flight.numberOfStops, renderContent);

    const destination = lastDestination(flight.flightSegments);
    const segmentAirlines = getAirlines(flight.flightSegments);

    const durationLabel = getDurationLabel(flight.totalDurationMins);
    const overnight = layoverDays({
      arrival: flight.arrivalDate,
      departure: flight.departDate,
    });

    const carrier = {
      name: flightSegment.operatingAirline.name,
      logo: flight.flightIcon,
      flightNumber: `${flightSegment.marketingAirline.code} ${departureflightNumber}`,
      operatedBy: `${renderContent(
        'flightSummaryOperatedBy',
        'Operated by',
      )} ${segmentAirlines.join(', ')}`,
      layover: `${segmentLayover} ${stopCodes}`,
      class: renderContent(
        `flightSummaryClass${flightSegment.cabinClass.code}Name`,
        flightSegment.cabinClass.name,
      ),
    };
    return {
      ...flight,
      carrier,
      destination,
      durationLabel,
      flightSegment,
      overnight,
      routeDirection,
      routeDirectionLabel,
      routeIndex,
    };
  });

  return (
    <Box>
      <PageSection className={classes.flightWrapper}>
        <Paper className={classes.FlightSummary}>
          <Box className={classes.cardWrapper}>
            {flights?.map((shuttle) => {
              return (
                <>
                  <CardSummary
                    key={shuttle.routeDirectionLabel}
                    className={classes.departure}
                    kind={shuttle.routeDirectionLabel}
                    date={localizedDayjs(shuttle.departDate).format('ddd, MMM D, YYYY')}
                    confirmationLabel={
                      shuttle.confirmationNumbers.length > 1
                        ? renderContent(
                            'displayingFlightsConfirmationNumbers',
                            `Confirmation numbers`,
                          )
                        : renderContent(
                            'displayingFlightsConfirmationNumber',
                            'Confirmation number',
                          )
                    }
                    confirmationNumbers={shuttle.confirmationNumbers}
                    departureAirport={shuttle.flightSegment.departure.airport.code}
                    arrivalAirport={shuttle.destination}
                    departureTime={shuttle.departTime}
                    arrivalTime={shuttle.arrivalTime}
                    flightDuration={shuttle.durationLabel}
                    linkHref=""
                    linkText=""
                    overnight={shuttle.overnight}
                    passengers={[passengers.toLowerCase()]}
                    summaryTitle={
                      passengers.split(',').length > 1
                        ? renderContent('displayingFlightsPassengers', `Passengers`)
                        : renderContent('displayingFlightsPassenger', `Passenger`)
                    }
                    carrier={shuttle.carrier}
                  />
                  <Divider variant="middle" className={classes.divider} />
                </>
              );
            })}
          </Box>
        </Paper>
      </PageSection>
    </Box>
  );
};

export default FlightSummary;
